import { takeEvery, takeLatest, fork, put, call, select } from "redux-saga/effects";

import { getGuideShownDate } from "state/school_money/selectors";
import { getMobileNumber } from "state/app/selectors";
import { getLocalStoreMobileNumber, clearData } from "state/localStore";
import * as actions from "state/school_money/actions";
import { PROCESS_METADATA, PROCESS_GOOGLE_PAY_RESPONSE } from "state/app/actions";

import fetchParentsSaga from "state/school_money/sagas/fetchParentsSaga";
import awaitParentsSaga from "state/school_money/sagas/awaitParentsSaga";
import fetchAllSaga from "state/school_money/sagas/fetchAllSaga";
import fetchSchoolsSaga from "state/school_money/sagas/fetchSchoolsSaga";
import fetchStudentsSaga from "state/school_money/sagas/fetchStudentsSaga";
import fetchActivePaymentsSaga from "state/school_money/sagas/fetchActivePaymentsSaga";
import fetchShopItemsSaga from "state/school_money/sagas/fetchShopItemsSaga";
import fetchHistorySaga from "state/school_money/sagas/fetchHistorySaga";
import updateParentEmailAddressSaga from "state/school_money/sagas/updateParentEmailAddressSaga";
import basketSaga from "state/school_money/sagas/basketSaga";
import createTransactionSaga from "state/school_money/sagas/createTransactionSaga";
import confirmTransactionSaga from "state/school_money/sagas/confirmTransactionSaga";
import completeCheckoutSaga from "state/school_money/sagas/completeCheckoutSaga";
import handlePaysafeErrorSaga from "state/school_money/sagas/handlePaysafeErrorSaga";
import handleSecureTradingErrorSaga from "state/school_money/sagas/handleSecureTradingErrorSaga";
import processMetadataSaga from "state/school_money/sagas/processMetadataSaga";
import goToClubBookingSaga from "state/school_money/sagas/goToClubBookingSaga";
import goToDinnerBookingSaga from "state/school_money/sagas/goToDinnerBookingSaga";
import goToPaymentSaga from "state/school_money/sagas/goToPaymentSaga";
import goToShopItemSaga from "state/school_money/sagas/goToShopItemSaga";
import goToParentalConsentItemSaga from "state/school_money/sagas/goToParentalConsentItemSaga";
import updateParentalConsentSaga from "state/school_money/sagas/updateParentalConsentSaga";
import markAsSeenSaga from "state/school_money/sagas/markAsSeenSaga";
import { secureTradingGetJWTString, secureTradingProcessPSD2Response, processGooglePayResponseSaga } from "state/school_money/sagas/secureTradingSaga";
import saveAuditSaga from "state/school_money/sagas/saveAudit";

/**
 * Root saga for school_money.
 * Attaches watchers and dispatches initial actions.
 */
export default function* schoolMoneySaga() {

  // attach watchers
  yield takeLatest(actions.PARENTS_FETCH, fetchParentsSaga);
  yield takeEvery(actions.FETCH_ALL, fetchAllSaga);
  yield takeEvery(actions.SCHOOLS_FETCH, fetchSchoolsSaga);
  yield takeEvery(actions.STUDENTS_FETCH, fetchStudentsSaga);
  yield takeEvery(actions.ACTIVE_PAYMENTS_FETCH, fetchActivePaymentsSaga);
  yield takeEvery(actions.SHOP_ITEMS_FETCH, fetchShopItemsSaga);
  yield takeEvery(actions.HISTORY_FETCH, fetchHistorySaga);
  yield takeEvery(actions.PARENT_EMAIL_ADDRESS_UPDATE, updateParentEmailAddressSaga);
  yield takeEvery(actions.PARENTAL_CONSENT_UPDATE, updateParentalConsentSaga);
  yield takeEvery(actions.CHECKOUT_START, createTransactionSaga);
  yield takeEvery(actions.CHECKOUT_TRANSACTION_PROCESS, confirmTransactionSaga);
  yield takeEvery(actions.CHECKOUT_COMPLETE, completeCheckoutSaga);
  yield takeEvery(actions.ERROR_PAYSAFE, handlePaysafeErrorSaga);
  yield takeEvery(actions.ERROR_SECURE_TRADING, handleSecureTradingErrorSaga);
  yield takeEvery(PROCESS_METADATA, processMetadataSaga);
  yield takeEvery(actions.CLUB_BOOKING_GO_TO, goToClubBookingSaga);
  yield takeEvery(actions.DINNER_BOOKING_GO_TO, goToDinnerBookingSaga);
  yield takeEvery(actions.PAYMENT_GO_TO, goToPaymentSaga);
  yield takeEvery(actions.SHOP_ITEM_GO_TO, goToShopItemSaga);
  yield takeEvery(actions.PARENTAL_CONSENT_ITEM_GO_TO, goToParentalConsentItemSaga);
  yield takeEvery(actions.SECURE_TRADING_GET_JWT_STRING, secureTradingGetJWTString);
  yield takeEvery(actions.SECURE_TRADING_PROCESS_PAYMENT_RESPONSE, secureTradingProcessPSD2Response);
  yield takeEvery(actions.SAVE_AUDIT, saveAuditSaga);
  yield takeEvery(PROCESS_GOOGLE_PAY_RESPONSE, processGooglePayResponseSaga);

  // set up basket
  yield fork(basketSaga);

  // handle mark_as_seen actions
  yield fork(markAsSeenSaga);

  // Clear out the local store if mobile number has changed
  yield* localStoreCleanUp();

  // wait for parent email address to be set
  yield put(actions.fetchParents(false));
  yield put(actions.fetchSchools(false));

  yield call(awaitParentsSaga);

  // dispatch initial actions
  yield put(actions.fetchAll(false, false, false, false, false, false));
  yield put(actions.validateBasketItems());

  // open the guide if it has not been shown before
  const guideShownDate = yield select(getGuideShownDate);
  if (guideShownDate === null) {
    yield put(actions.openGuide());
  }

}

// Clear out the local store if mobile number changed
function* localStoreCleanUp() {
  const currentMobileNumber = yield select(getMobileNumber);
  const localStoreMobileNumber = getLocalStoreMobileNumber();

  if(localStoreMobileNumber !== undefined && currentMobileNumber !== localStoreMobileNumber) {
    clearData();
  }
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/index.js